import { Suspense, useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { RdIntro, RdHeader, RdFooter, RdMobileBar } from "./redesign/RdChrome";
import { RdCursor } from "./redesign/RdCursor";
import { AssistantWidget } from "./assistant/AssistantWidget";
import { trackPageView } from "../lib/analytics";

export default function Layout() {
  const location = useLocation();
  const navigate = useNavigate();
  const reduce = useReducedMotion();

  /* SPA navigation for raw <a href="/..."> links inside injected prose HTML */
  useEffect(() => {
    const onClick = (e) => {
      const a = e.target.closest && e.target.closest("a");
      if (!a || e.defaultPrevented || a.target === "_blank") return;
      const href = a.getAttribute("href");
      if (!href || /^(https?:|mailto:|tel:)/.test(href)) return;
      if (href.startsWith("/")) { e.preventDefault(); navigate(href); }
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, [navigate]);

  /* hash scrolling / scroll-to-top on route change */
  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    if (location.hash) {
      const id = decodeURIComponent(location.hash.slice(1));
      const t = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 120);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [location.pathname, location.hash]);

  return (
    <>
      <RdCursor />
      <RdIntro />
      <RdHeader />
      <AnimatePresence mode="wait" initial={false}>
        <motion.div key={location.pathname}
          initial={reduce ? false : { opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          exit={reduce ? { opacity: 0 } : { opacity: 0, y: -12 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}>
          <Suspense fallback={<div style={{ minHeight: "100vh" }} />}><Outlet /></Suspense>
        </motion.div>
      </AnimatePresence>
      <RdFooter />
      <RdMobileBar />
      <AssistantWidget />
    </>
  );
}
